import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@components/ui/dialog';
import { DayCard } from './DayCard';
import type { DayActivityData } from '../utils/useActivityData';
import type { ActivityItem } from './ActivityList';

interface FullscreenDialogProps {
    open: boolean;
    onClose: () => void;
    dayDataArray: DayActivityData[];
    selectedDatesCount: number;
    onActivityClick?: (activity: ActivityItem) => void;
}

export function FullscreenDialog({
    open,
    onClose,
    dayDataArray,
    selectedDatesCount,
    onActivityClick
}: FullscreenDialogProps) {
    return (
        <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
            <DialogContent className="block h-[95vh] w-[95vw] max-w-none overflow-auto p-8 pt-12 sm:max-w-none">
                <DialogTitle className="sr-only">Fullscreen view</DialogTitle>
                <div className="flex gap-6">
                    {dayDataArray.map((dayData) => {
                        const dateKey = dayData.date
                            .toISOString()
                            .split('T')[0];
                        return (
                            <DayCard
                                key={dateKey}
                                dayData={dayData}
                                isOnlyDay={selectedDatesCount === 1}
                                onActivityClick={onActivityClick}
                            />
                        );
                    })}
                </div>
            </DialogContent>
        </Dialog>
    );
}
